import chatLog from '../../global/chat-log'
import * as xmpp from '../../global/xmppPayloadHelper'
import { send } from './serverConnection'

/**
 * Set my presence for others to see
 */
export const setPresence = ({ connection }) => {
  const stanza = xmpp.payloadToSetPresenceStatus()
  return send({ connection, stanza })
}

/*
  Notify the server of the availability status.
*/
export const enableNofificationsFromServer = ({ connection }) => {
  chatLog(`[Profile] Enabling notifications from the server.`)
  return setPresence({ connection })
}
